import { render, staticRenderFns } from "./AddPosition.vue?vue&type=template&id=84e5f67a&scoped=true"
import script from "./AddPosition.vue?vue&type=script&lang=js"
export * from "./AddPosition.vue?vue&type=script&lang=js"
import style0 from "./AddPosition.vue?vue&type=style&index=0&id=84e5f67a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e5f67a",
  null
  
)

export default component.exports